import React ,{useEffect}from 'react';
import { useTheme } from '@mui/material';
import comingSoonImagew from '../../Images/commingsoonw.png'; // Make sure to add an image in your project
import comingSoonImageb from '../../Images/commingsoonb.png'
import {checkprotectedroutes, setActivity} from '../../Global/Index'
import {toast } from 'react-toastify';
import HeaderOuter from '../Nav Bar/HeaderOuter';
import './PageNotfound.css';
import ShortcutButton from '../Layout Shortcut/Shortcut';

const PageNotFound = () => {
    const theme=useTheme();

    useEffect(() => {
        const checkfun = async () => {
          setActivity('Chat With Us Page')
          const resp = await checkprotectedroutes();
          if(resp.response.status === "419") {
            window.location.href = '/Session-Expired'
          } else if (resp.response.status === "500") {
            toast.error('Something went wrong. Please try again later!')
          } else if (resp.response.status === "503") {
            toast.warn(resp.response.message);
          }else if(resp.response.status=='401'){
            window.location.href='/'
          }
        }
        checkfun()
      }, [])

    return (
        <>
        <HeaderOuter/>
        <ShortcutButton/>
        <div className="not-found-container" style={{ color: theme.palette.primary.main }}>
           {
            theme.palette.mode === "dark"?<img src={comingSoonImageb} alt="Coming Soon" className="not-found-image" styele={{marginTop:'-2vw'}} />:<img src={comingSoonImagew} alt="Coming Soon" className="not-found-image" styele={{marginTop:'-2vw'}} />
           } 
        </div>
        </>
    );
};

export default PageNotFound;